/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
function RadioTileGroup(_ref) {
  var name = _ref.name,
      _onChange = _ref.onChange,
      selectedTile = _ref.selectedTile,
      tiles = _ref.tiles;
  return React.createElement("ul", {
    className: "radio-tile-group"
  }, tiles.map(function (tile) {
    return React.createElement("li", {
      key: tile.value,
      className: "radio-tile"
    }, React.createElement("input", {
      type: "radio",
      value: tile.value,
      id: tile.identifier,
      checked: selectedTile === tile.value,
      name: name,
      onChange: function onChange(event) {
        return _onChange(event.target.value);
      }
    }), React.createElement("label", {
      htmlFor: tile.identifier
    }, tile.label));
  }));
}

export default RadioTileGroup;